__turbopack_context__.v({
  "masonryGrid": "PreviousGallery-module-scss-module__XszJoG__masonryGrid",
  "masonryGridColumn": "PreviousGallery-module-scss-module__XszJoG__masonryGridColumn",
  "masonryItem": "PreviousGallery-module-scss-module__XszJoG__masonryItem",
});
